import React from 'react';

import { type FWaypointTemplateFragment } from '@dashboard/generated/wp/platform';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { NorthEastOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

import SampleTemplateCard from '../../../../WaypointTemplatesList/CreateTemplateButton/ChooseTemplateDialog/SampleTemplateCard';

type Props = {
  active: boolean;
  template: FWaypointTemplateFragment;
  onClick: () => void;
};
export default function LayoutSelectorTemplateCard({ active, template, onClick }: Props) {
  const platformId = useCurrentPlatformId();
  const p = {
    active,
    template,
    onClick,
  };

  return (
    <SampleTemplateCard
      {...p}
      title={template.name}
      actions={
        <>
          <Tooltip title="Edit layout">
            <IconButton
              type="button"
              size="small"
              href={`/o/${platformId}/templates/${template.id}`}
              target="_blank"
              onClick={(ev) => {
                ev.stopPropagation();
              }}
            >
              <NorthEastOutlined sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        </>
      }
    />
  );
}
